import AnnualChristmasCelebration from "../assets/events/christmas.jpg";
import NewYearGala from "../assets/events/New Year Gala.jpeg";
import CommunityOutreach from "../assets/events/Community Outreach Program.jpg";
import EasterService from "../assets/events/Easter Service.jpg";
import YouthRetreat from "../assets/events/Youth Retreat.webp";
import MusicFest from "../assets/events/Music Fest.jpg";
import Thanksgiving from "../assets/events/Thanksgiving.jpg";
import SpringCleanupDrive from "../assets/events/Spring Cleanup Drive.jpeg";

export const eventsData = [
  {
    name: "Annual Christmas Celebration",
    date: "2024-12-25",
    pic: AnnualChristmasCelebration,
  },
  {
    name: "New Year Gala",
    date: "2024-12-31",
    pic: NewYearGala,
  },
  {
    name: "Community Outreach Program",
    date: "2024-11-15",
    pic: CommunityOutreach,
  },
  {
    name: "Easter Service",
    date: "2024-03-31",
    pic: EasterService,
  },
  {
    name: "Youth Retreat",
    date: "2024-08-20",
    pic: YouthRetreat,
  },
  {
    name: "Music Fest",
    date: "2024-07-05",
    pic: MusicFest,
  },
  {
    name: "Thanksgiving Dinner",
    date: "2024-11-28",
    pic: Thanksgiving,
  },
  {
    name: "Spring Cleanup Drive",
    date: "2024-04-10",
    pic: SpringCleanupDrive,
  },
];
